import { formatNumber, Location } from '@angular/common';
import { Component } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@devinforius/i-essentials';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, Subscription } from 'rxjs';
import { Mail, MailInfosViaExtraStateRouter } from 'src/app/shared/models/mails/mail';
import { DataService } from 'src/app/shared/services/data.service';

@Component({
  selector: 'app-creation-courrier',
  templateUrl: './creation-courrier.component.html',
  styleUrls: ['./creation-courrier.component.scss'],
})
export class CreationCourrierComponent {
  public mailMode = '';
  public formOutput: FormData; // to send Formdata in editor
  public fullscreenMode: boolean;
  public visible = true;
  public tab = 'Infos';
  public form: UntypedFormGroup;
  public isFormSubmit = false;
  public newMail: Mail = null;
  public canSubmit = false;
  globalSubmitESubject: Subject<void> = new Subject<void>();
  switchToFileSubject: Subject<void> = new Subject<void>();
  public isFormValid = false;
  public dataCreateSubscription: Subscription;
  public typeEntranSortant = 'E';
  public buttons = [
    {
      text: 'Retour',
      styleClass: 'blue',
      id: 'creaCourrierBack',
      disabled: false,
      tooltip: '',
      click: () => {
        this.back();
      },
    },
    {
      text: 'Enregistrer',
      styleClass: 'green',
      id: 'creaCourrierSave',
      disabled: true,
      tooltip: '',
      click: () => {
        this.submit();
      },
    },
  ];
  public answerMail: Mail = null;
  public dataMailCreation: MailInfosViaExtraStateRouter = {
    isAnswerMode: false,
    isNew: true,
    mailMode: 'edit',
    mailType: 'E',
  };
  public title = "Création d'un courrier";
  public loaded = false;

  public createNewCourrierForIDelibe = false;
  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public location: Location,
    public dataService: DataService,
    public spinner: NgxSpinnerService,
    public translater: TranslateService
  ) {
    if (this.router.getCurrentNavigation()) {
      const stateOfRouter = this.router.getCurrentNavigation().extras.state;
      if (stateOfRouter) {
        this.dataMailCreation = stateOfRouter;
      }
      if (this.dataMailCreation && this.dataMailCreation.isAnswerMode) {
        if (this.dataMailCreation.mailId) {
          const id = formatNumber(this.dataMailCreation.mailId, 'es');
          this.title = this.translater.translate('editCourrier.answerToTheMail#') + (this.dataMailCreation.mailId ? id : null);
        }
      }
    }
    if (this.route.snapshot.url[0]?.path === 'new-from-idelibe') {
      this.dataMailCreation.mailType = 'S';
      this.createNewCourrierForIDelibe = true;
    }
  }

  receiveLinkMailId(id): void {
    sessionStorage.setItem('oldCourrier', id.toString());
  }

  receiveFormState(event): void {
    this.form = event.form;
    this.isFormSubmit = event.isFormSubmit;
  }

  receiveTabs(tab): void {
    this.tab = tab;
  }

  public receiveMailMode(event): void {
    this.mailMode = event;
  }

  public receiveNewMail(mail: Mail): void {
    this.newMail = mail;
    if (this.newMail) {
      this.router.navigate(['/private/ic/tabs/' + this.newMail.id]);
    }
  }

  public onFormChangeEvent(formData): void {
    this.formOutput = formData;
  }

  public canSubmitReceived(canSubmit: boolean): void {
    if (canSubmit === true) {
      this.canSubmit = true;
    } else {
      this.canSubmit = false;
    }
  }

  public receiveFormValidSt(isFormValid: boolean): void {
    this.isFormValid = isFormValid;
    if (this.isFormValid) {
      this.buttons[1].disabled = false;
    } else {
      this.buttons[1].disabled = true;
    }
  }

  back(): void {
    localStorage.removeItem('iCourrier_point_id_send');
    this.location.back();
  }

  submit(): void {
    this.isFormSubmit = true;

    this.globalSubmitESubject.next();
    if (this.dataMailCreation?.mailType === 'S') {
      sessionStorage.setItem('showDestinataireModal', '1');
    } else {
      sessionStorage.removeItem('showDestinataireModal');
    }
  }
}
